import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../core';
import { environment } from 'environments/environment';
import { PermissionMenuResponse } from './response/permission-menu.response';
import { PermissionNavigationResponse } from './response/permission-navigation.response';

@Injectable()
export class PermissionService extends BaseService {
  private controllerEndpoint = `${environment.urlEdducaImobApi}api/Permission/`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  getPermissionsAndNavigations(loader = true): Observable<PermissionNavigationResponse> {
    return this.httpClient.get<PermissionNavigationResponse>(
      `${this.controllerEndpoint}Navigations`,
      { headers: this.getHeader(loader) }
    );
  }

  getPermissionsByCompanyId(companyId: number, loader = true): Observable<PermissionMenuResponse[]> {
    return this.httpClient.get<PermissionMenuResponse[]>(
      `${this.controllerEndpoint}Company/${companyId}`,
      { headers: this.getHeader(loader) }
    );
  }

  getPermissionsByProfileSystemId(profileSystemId: number, loader = true): Observable<PermissionMenuResponse[]> {
    return this.httpClient.get<PermissionMenuResponse[]>(
      `${this.controllerEndpoint}ProfileSystem/${profileSystemId}`,
      { headers: this.getHeader(loader) }
    );
  }
}
